import Vue from 'vue'
import { dateFormat, dateToNow, secondToDate } from './modules/date'

Vue.filter('dateFormat', dateFormat)
Vue.filter('dateToNow', dateToNow)
Vue.filter('secondToDate', secondToDate)
